import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
} from '@angular/forms';
import { UiModalComponent } from '@components';
import {
    ILicenseRequest,
    LicenseEnvironment,
    LicenseFormControl,
    ModalResultType,
} from '@models';
import { TranslateService } from '@ngx-translate/core';

import { BehaviorSubject } from 'rxjs';

@Component({
    templateUrl: './activate-online.modal.html',
    styleUrls: ['./activate-online.modal.scss'],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class ActivateOnlineModalComponent
    extends UiModalComponent<ILicenseRequest>
    implements OnInit {

    public loading$ = new BehaviorSubject(false);

    public formGroup!: FormGroup;

    public LicenseFormControl = LicenseFormControl;

    private _translateService = this._injector.get<TranslateService>(TranslateService);

    ngOnInit() {
        this.context.data = {
            installationId: this.context.data.installationId,
            licenseKey: '',
            environment: LicenseEnvironment.Production,
            offline: this.context.data.offline,
        } as ILicenseRequest;

        this.formGroup = this._injector.get<FormBuilder>(FormBuilder).group({
            [LicenseFormControl.installationId]: [
                this.context.data.installationId,
            ],
            [LicenseFormControl.licenseKey]: [
                this.context.data.licenseKey,
            ],
            [LicenseFormControl.environment]: [
                this.context.data.environment,
            ],
        });
    }

    public clipboardCopied() {
        this._snack.success(this._translateService.instant('global_message_copied_clipboard'));
    }

    public openOfflineModal() {
        this._dialogRef.close({
            type: ModalResultType.Failed,
        });
    }

    public get isSubmitDisabled() {
        return this.loading$.value ||
            !this.formGroup ||
            !this.formGroup.dirty ||
            this.formGroup.invalid;
    }

    public onSubmit() {
        if (this.isSubmitDisabled) { return; }

        const licenseKey = this.formGroup.get(LicenseFormControl.licenseKey)!.value;
        const environment = this.formGroup.get(LicenseFormControl.environment)!.value;

        this._dialogRef.close({
            type: ModalResultType.Add,
            data: {
                installationId: this.context.data.installationId,
                licenseKey: licenseKey,
                environment: environment,
            },
        });
    }
}
